export default __webpack_public_path__ + "static/media/ico_heating.b3d6733e.svg";